import { GlobalIcon, Typography } from "get-life-storybook-ts";

interface IntermediaryBadgeProps {
  translate: (key: string) => string;
  /** Compact one-line strip (mobile mini variant). Defaults to full card. */
  compact?: boolean;
}

const IntermediaryBadge = ({ translate, compact = false }: IntermediaryBadgeProps) => {
  if (compact) {
    return (
      <div className="w-full px-3 py-2 bg-blue-gray-50 border-b border-blue-gray-200 flex items-center gap-2">
        <GlobalIcon iconName="ShieldCheckIcon" size="XS" color="#424242" />
        <Typography
          variant="BodyXSmall"
          weight="500"
          text={`${translate("compliance.upsell.it.intermediary.label")} · ${translate("compliance.upsell.it.intermediary.carrier")}`}
          className="text-blue-gray-800 leading-tight"
        />
      </div>
    );
  }

  return (
    <div className="max-w-[960px] mx-auto mb-4 px-4 py-4 border border-blue-gray-200 rounded-lg bg-blue-gray-50 flex items-start gap-3">
      <GlobalIcon iconName="ShieldCheckIcon" size="S" color="#424242" />
      <div className="flex flex-col gap-1 flex-1">
        <Typography
          variant="BodySmall"
          weight="700"
          text={translate("compliance.upsell.it.intermediary.label")}
          className="text-blue-gray-900"
        />
        <Typography
          variant="BodySmall"
          weight="400"
          text={translate("compliance.upsell.it.intermediary.carrier")}
          className="text-blue-gray-800"
        />
        <Typography
          variant="BodyXSmall"
          weight="400"
          text={translate("compliance.upsell.it.intermediary.role")}
          className="text-blue-gray-600"
        />
      </div>
    </div>
  );
};

export default IntermediaryBadge;
